const APP_VERSION = '1.10.18';

export default APP_VERSION;
